// @flow

import React from "react"
import { A } from "../layout"
import { SERVER_SIDE } from "../utils"

export default class Navigation extends React.Component<*> {
    componentDidMount() {
        if (!SERVER_SIDE) {
            // TODO - Not sure why this path has to be explicit
            // $FlowExpectError
            const M = require("../../../node_modules/materialize-css/dist/js/materialize.js")
            const nav = document.querySelectorAll(".sidenav")
            return M.Sidenav && M.Sidenav.init(nav)
        }
    }

    render() {
        return (
            <nav className="white z-depth-1">
                <div
                    className="nav-wrapper"
                    style={{ marginLeft: 25, marginRight: 25 }}>
                    <a
                        href="/"
                        className="brand-logo"
                        style={{
                            fontWeight: 500,
                            color: "#424242",
                        }}>
                        <span
                            className="fa fa-home"
                            style={{
                                color: "#4caf50",
                                fontSize: 40,
                                verticalAlign: "middle",
                                marginRight: 10,
                                marginBottom: 5,
                            }}
                        />
                        SimplyRETS
                    </a>
                    <a
                        href="#"
                        data-target="mobile-demo"
                        className="sidenav-trigger"
                        style={{ float: "right" }}>
                        <i
                            className="fa fa-bars"
                            style={{ color: "#424242", fontSize: 25 }}
                        />
                    </a>
                    <ul className="right hide-on-med-and-down">
                        <li className="small-media-hide">
                            <a
                                className="grey-text text-darken-4"
                                href="/services">
                                Services
                            </a>
                        </li>
                        <li className="small-media-hide">
                            <a
                                className="grey-text text-darken-4"
                                href="/#home-pricing">
                                Plans & pricing
                            </a>
                        </li>
                        <li>
                            <A
                                outbound
                                className="grey-text text-darken-4"
                                href="https://docs.simplyrets.com">
                                Documentation
                            </A>
                        </li>
                        <li>
                            <a className="grey-text text-darken-4" href="/blog">
                                Blog
                            </a>
                        </li>
                        <li className="small-media-hide">
                            <a
                                className="grey-text text-darken-4"
                                href="/#home-contact">
                                Contact us
                            </a>
                        </li>
                        <li>
                            <a
                                className="grey-text text-darken-4"
                                href="/account">
                                Account Panel
                            </a>
                        </li>
                    </ul>
                </div>

                <ul className="sidenav" id="mobile-demo">
                    <li>
                        <a className="grey-text text-darken-4" href="/services">
                            Services
                        </a>
                    </li>
                    <li>
                        <a
                            className="grey-text text-darken-4"
                            href="#home-pricing">
                            Plans & pricing
                        </a>
                    </li>
                    <li>
                        <A
                            outbound
                            className="grey-text text-darken-4"
                            href="https://docs.simplyrets.com">
                            Documentation
                        </A>
                    </li>
                    <li>
                        <a className="grey-text text-darken-4" href="/blog/">
                            Blog
                        </a>
                    </li>
                    <li>
                        <a className="grey-text text-darken-4" href="/account">
                            Account
                        </a>
                    </li>
                </ul>
            </nav>
        )
    }
}
